import React, { useEffect, useRef, useState } from 'react';
import { CategoryWrapper } from './style';

const CategoryButtonComponent = ({
  categoryList,
  onClickCategoryBtn,
  selectedCategoryCd,
}) => {
  const [scrollEnd, setScrollEnd] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;

    if (!el) return;

    const onTouchMove = e => {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      const isAtStart = scrollLeft === 0;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      if ((isAtStart && e.deltaX < 0) || (isAtEnd && e.deltaX > 0)) {
        e.preventDefault();
      }

      if (isAtEnd) {
        setScrollEnd(true);
      } else setScrollEnd(false);
    };

    el.addEventListener('wheel', onTouchMove, { passive: false });
    el.addEventListener('touchmove', onTouchMove, { passive: false });

    return () => {
      el.removeEventListener('wheel', onTouchMove);
      el.removeEventListener('touchmove', onTouchMove);
    };
  }, []);

  return (
    <CategoryWrapper scrollEnd={scrollEnd}>
      <div className="scrollContainer" ref={scrollRef}>
        {categoryList?.map((item, index) => (
          <button
            className={item.code === selectedCategoryCd ? 'isactive' : ''}
            key={item.code}
            onClick={() => onClickCategoryBtn(item.code)}
          >
            {item.codeName}
          </button>
        ))}
      </div>
    </CategoryWrapper>
  );
};

export default CategoryButtonComponent;
